import { render, staticRenderFns } from "./ProductTagsList.vue?vue&type=template&id=a0ea3730&"
import script from "./ProductTagsList.vue?vue&type=script&lang=js&"
export * from "./ProductTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports